import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "payment-type-logo-item-frame"
}

import { computed, type PropType } from "vue";
import { type CardPaymentLogo } from "../../checkout/payment-type/image-urls";
import cardFrame from "./card-frame.vue";
import PaymentImage from "../../checkout/shop-checkout/payment-image.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentCardItem',
  props: {
    cardPaymentLogo: {
        type: Object as PropType<CardPaymentLogo>,
        required: true,
    },
    lazy: Boolean,
},
  setup(__props) {

const props = __props;

const imgData = computed(() => {
    const cardPaymentLogo = props.cardPaymentLogo;
    if ("icon" in cardPaymentLogo && cardPaymentLogo.icon != null) {
        return cardPaymentLogo.icon.data;
    }
    return cardPaymentLogo.data;
});

return (_ctx: any,_cache: any) => {
  return (__props.cardPaymentLogo != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(cardFrame, { class: "payment-item-border" }),
        _createVNode(PaymentImage, {
          "image-data": imgData.value,
          alt: __props.cardPaymentLogo.key + ' logo',
          lazy: __props.lazy,
          class: "payment-type-logo-item"
        }, null, 8 /* PROPS */, ["image-data", "alt", "lazy"])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})